// Lib
import { isEqual } from 'lodash/fp';

// Utils
import {
    getNotificationCommentIsReply,
    getNotificationCommentThreadIdsAsArray,
    getNotificationElementId,
    getNotificationType,
    getNotificationUserId,
} from './notificationModelUtils';

// Constants
import { NotificationType } from './notificationConstants';

const areUserIdAndElementIdEqual = (notificationA, notificationB) =>
    getNotificationUserId(notificationA) === getNotificationUserId(notificationB) &&
    getNotificationElementId(notificationA) === getNotificationElementId(notificationB);

const areCommentNotificationsMergeable = (notificationA, notificationB) => {
    if (getNotificationCommentIsReply(notificationA) || getNotificationCommentIsReply(notificationB)) {
        return (
            areUserIdAndElementIdEqual(notificationA, notificationB) &&
            isEqual(
                getNotificationCommentThreadIdsAsArray(notificationA),
                getNotificationCommentThreadIdsAsArray(notificationB),
            )
        );
    }

    return areUserIdAndElementIdEqual(notificationA, notificationB);
};

/**
 * Determines if the properties of two notifications are similar enough to merge together or delete.
 */
export default (notificationA, notificationB) => {
    const notificationType = getNotificationType(notificationA);
    if (notificationType !== getNotificationType(notificationB)) return false;

    switch (notificationType) {
        case NotificationType.ASSIGNMENT:
        case NotificationType.BOARD_VIEW:
        case NotificationType.BOARD_UPDATE:
        case NotificationType.BOARD_TASKS_UPDATE:
        case NotificationType.BOARD_TASKS_REMINDER:
        case NotificationType.SHARE_REMINDER:
        case NotificationType.REACTION:
            return areUserIdAndElementIdEqual(notificationA, notificationB);
        case NotificationType.COMMENT:
            return areCommentNotificationsMergeable(notificationA, notificationB);
        default:
            return false;
    }
};
